import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../controls";
import { Box } from "@mui/material";
import { CSVLink } from "react-csv";

const HeaderComp = ({ access, handleAddEdit, tblData, csvHeader }) => {
  const { t } = useTranslation();

  return (
    <div className="d-flex flex-wrap g-5">
      {access.isHaveAddAccess && (
        <Button
          variant="text"
          onClick={handleAddEdit}
          sx={{
            width: { md: "180px", xs: "100%" },
            mb: { xs: "10px", md: "0px" },
            fontSize: "17px",
            padding: "8px",
          }}
        >
          {t("addUser")}
        </Button>
      )}
      {access.isHaveExportAccess && (
        <Box
          className="d-flex"
          sx={{
            width: { xs: "100%", md: "auto" },
          }}
        >
          <CSVLink
            data={tblData}
            headers={csvHeader}
            filename={`${t("user")} (${new Date().toDateString()}).csv`}
            target="_blank"
            className="d-flex a-center j-center p-15 fs-16 fw-5 tx-upp primary-color bg-primarySM br-15"
          >
            {t("exportCSV")}
          </CSVLink>
        </Box>
      )}
    </div>
  );
};

export default HeaderComp;
